// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.planTimeline_timelineContainer__4p8mr {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 20px;
  box-sizing: border-box;
  border-radius: 16px;
}

.planTimeline_timelineContent__vhhdm {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  position: relative;
}

.planTimeline_timelineLine__pFj-y {
  width: 7px;
  height: 52px;
  position: absolute;
  left: 0;
  top: 0;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.planTimeline_timelineLine__pFj-y svg {
  width: 100%;
  height: 100%;
  display: block;
}

.planTimeline_timelineItems__X6Arc {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1 1;
  min-width: 0;
  position: relative;
  padding-left: 15px;
}

.planTimeline_timelineItem__Se6W8 {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  position: relative;
}

.planTimeline_timelineText__ngdLk {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 1;
  min-width: 0;
  width: 100%;
}

.planTimeline_timelineLabel__469ft {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #9396a3;
  white-space: nowrap;
}

.planTimeline_timelineValue__tJqBk {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #f3f4f6;
  white-space: nowrap;
}

.planTimeline_divider__ufl9t {
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0) 100%);
}

.planTimeline_activationText__XqXXm {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #9396a3;
  text-align: center;
  white-space: pre-wrap;
}

`, "",{"version":3,"sources":["webpack://./src/components/pwatv/PlanTimeline/planTimeline.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAO;EACP,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,wHAAwH;AAC1H;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB","sourcesContent":[".timelineContainer {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 0 20px;\n  box-sizing: border-box;\n  border-radius: 16px;\n}\n\n.timelineContent {\n  display: flex;\n  gap: 8px;\n  align-items: flex-start;\n  position: relative;\n}\n\n.timelineLine {\n  width: 7px;\n  height: 52px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  flex-shrink: 0;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.timelineLine svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.timelineItems {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex: 1;\n  min-width: 0;\n  position: relative;\n  padding-left: 15px;\n}\n\n.timelineItem {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  position: relative;\n}\n\n.timelineText {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex: 1;\n  min-width: 0;\n  width: 100%;\n}\n\n.timelineLabel {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #9396a3;\n  white-space: nowrap;\n}\n\n.timelineValue {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #f3f4f6;\n  white-space: nowrap;\n}\n\n.divider {\n  width: 100%;\n  height: 1px;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0) 100%);\n}\n\n.activationText {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #9396a3;\n  text-align: center;\n  white-space: pre-wrap;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timelineContainer": `planTimeline_timelineContainer__4p8mr`,
	"timelineContent": `planTimeline_timelineContent__vhhdm`,
	"timelineLine": `planTimeline_timelineLine__pFj-y`,
	"timelineItems": `planTimeline_timelineItems__X6Arc`,
	"timelineItem": `planTimeline_timelineItem__Se6W8`,
	"timelineText": `planTimeline_timelineText__ngdLk`,
	"timelineLabel": `planTimeline_timelineLabel__469ft`,
	"timelineValue": `planTimeline_timelineValue__tJqBk`,
	"divider": `planTimeline_divider__ufl9t`,
	"activationText": `planTimeline_activationText__XqXXm`
};
export default ___CSS_LOADER_EXPORT___;
